<template>
  <div class="rightBottom">
    <div class="tabulationBottom">
      <el-table :data="rows" :show-header="false" border size="mini" :cell-style="cellStyle">
        <af-table-column
          v-for="(item,index) in rows[0]"
          :prop="index + ''"
          :fixed="index == 0 ? true : false "
          :label="item[index + '']"
          :key="index"
        ></af-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["titles", "rows"],

  data() {
    return {};
  },
  mounted() {
    // console.log(this.titles, this.rows);
  },
  methods: {
    cellStyle(row, column, rowIndex, columnIndex) {
      if (row.columnIndex == 0 || row.rowIndex == 0) {
        return "color: #DFECF7;font-weight:bold;font-family:Microsoft YaHei;background:rgba(5, 43, 79, 0.8) !important;";
      }
    
    }
  }
};
</script>

<style scoped lang='less'>
.rightBottom {
  width: 100%;
  height: 444px;
  overflow: auto;
  .tabulationBottom {
    width: 100%;
  }
}
/deep/ .el-table--border td,
.el-table--border th {
  background: rgba(5, 43, 79, 1) ;
  border: 1px solid #08396a !important;
}
/deep/ .el-table::before,
/deep/ .el-table--border::after {
  background: none;
}
/deep/ .el-table--border th,
.el-table--border th.gutter:last-of-type {
  background: rgba(5, 43, 79, 0.8) !important;
  border: 1px solid #08396a !important;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dfecf7;
}
/deep/ tbody tr {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #dfecf7;
}
/deep/ .el-table--border,
/deep/.el-table--group {
  border: 0;
}
/deep/ .el-table__fixed::before {
  background: none;
}
/deep/ .el-table__row {
  pointer-events: none;
}
/deep/.el-table--enable-row-hover .el-table__body tr > td {
  pointer-events: none;
  //   background-color: #F5F7FA;
  //   color:#000;
}
/deep/ .el-table__empty-block {
  width: 100% !important;
  background: #052b4f;
}
/deep/ .el-table__body-wrapper {
  background: #052b4f !important;
}

</style>


// WEBPACK FOOTER //
// src/components/table3.vue